import { useState, useEffect } from 'react';
import axios from 'axios';
import styles from '../styles/FilterSidebar.module.css';
import CustomDateInput from '../customComponents/CustomDateInput';
import CustomRangeSlider from '../customComponents/CustomRangeSlider';
import CustomSelect from '../customComponents/CustomSelect';
import { API_URL } from '../config/api';

const FilterSidebar = ({ onClose, onApplyFilters }) => {
  const [priceRange, setPriceRange] = useState([0, 100000]);
  const [warehouse, setWarehouse] = useState(null);
  const [storages, setStorages] = useState([]);
  const [date, setDate] = useState('');

  useEffect(() => {
    const fetchStorages = async () => {
      try {
        const response = await axios.get(`${API_URL}/api/storages`);
        setStorages(response?.data?.data || []);
      } catch (error) {
        console.error('Ошибка при загрузке складов:', error);
        setStorages([]);
      }
    };

    fetchStorages();
  }, []);

  const storageOptions = storages.map((s) => ({
    label: s.name || `Склад #${s.id}`,
    value: s,
  }));

  return (
    <div className={styles.sidebar_bg}>
      <div className={styles.sidebar}>
        <div className={styles.header}>
          <h3 className={styles.headerText}>Фильтр данных</h3>
          <button className={styles.closeButton} onClick={onClose}></button>
        </div>

        <div className={styles.section}>
          <CustomSelect
            options={storageOptions}
            value={warehouse}
            onChange={(val) => setWarehouse(val)}
            placeholder="Выберите склад"
          />
        </div>

        <div className={styles.section}>
          <CustomDateInput value={date} onChange={setDate} />
        </div>

        <div className={styles.sectionPrice}>
          <label className={styles.labelText}>Цена продажи (₸)</label>
          <CustomRangeSlider
            min={0}
            max={100000}
            value={priceRange}
            onChange={setPriceRange}
          />
        </div>

        <div className={styles.sectionCheckbox}>
          <label className={styles.checkboxContainer}>
            <input type="checkbox" />
            <span className={styles.customCheckbox}></span>
            <span className={styles.checkboxLabel}>В наличии</span>
          </label>

          <label className={styles.checkboxContainer}>
            <input type="checkbox" />
            <span className={styles.customCheckbox}></span>
            <span className={styles.checkboxLabel}>Весовой товар</span>
          </label>
        </div>

        <button
          className={styles.applyButton}
          onClick={() => {
            const filters = {};

            // склад
            if (warehouse?.id) filters.storage_id = warehouse.id;

            // дата (оставил как есть, т.к. не знаю формат твоего CustomDateInput)
            if (date) filters.date = date;

            // цена (если нужно отправлять)
            if (Array.isArray(priceRange)) {
              filters.price_from = priceRange[0];
              filters.price_to = priceRange[1];
            }

            onApplyFilters(filters);
            onClose();
          }}
        >
          Применить
        </button>
      </div>
    </div>
  );
};

export default FilterSidebar;
